import { templateTypes } from '../../../tornado/templates/templateTypes';

export const facets = {
  PLAYLIST: 'playlist',
  PROGRAM: 'program',
  VC: 'vc',
  VI: 'vi',
  PODCAST: 'podcast',
};

export const facetsOrder = [facets.PLAYLIST, facets.PROGRAM, facets.VC, facets.VI, facets.PODCAST];

export const templateIdForFacets = {
  [facets.PLAYLIST]: templateTypes.PosterM,
  [facets.PROGRAM]: templateTypes.PosterM,
  [facets.VI]: templateTypes.PosterM,
  [facets.VC]: templateTypes.PosterM,
  [facets.PODCAST]: templateTypes.HorizontalSquare,
};
